export const BrowserNotificationPermission = {
  DEFAULT: 'default',
  GRANTED: 'granted',
  DENIED: 'denied'
} as const;
